import React from"react"; // Need React to output some React nodes

export default {
    withLineBreakAsHtml(input) {
        return input.split('\n').map( (item, key) => <span key={key}>{item}<br/></span> );
    }
};





// WEBPACK FOOTER //
// ./js/mywort/commons/utils/StringUtils.js